import React, { useEffect, useState } from "react";
import { useMedia } from "use-media";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import CatalogQuestion from '../../catalogQuestion';
import catalog_title_img from "../../resources_catalog/images/catalog_title_img.svg";
import { useRtoaster } from "../../hooks/useRtoaster";

export const CatalogQuestionContainer = (props) => {
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });
  const [linkList, setLinkList] = useState([]);
  const history = useHistory();
  const onClickBack = () => {
    history.push(props.path);
  }

  // rtoasterタグ生成
  useRtoaster();

  useEffect(() => {
    setLinkList([{ path: "/rtcc/catalog/home", label: "ホーム" }]);
  }, []);

  return (
    <div className="catalogContentWrap">
      <div className="catalogContent">
        <div className="catlogBackBlock"></div>
        <div className="catalogContentsBlock">
          <div className="catalogContentsTitle">
            <img src={catalog_title_img} alt="" className="catalogContentsTitleImg" />
            <p>よくあるご質問</p>
            <p className="catalogContentsTitleCaption">Q&A</p>
          </div>
          <div className="catalogContentsQuestion">
            <CatalogQuestion />
          </div>
        </div>
      </div>
      <div className={isWideTablet ? "none" : "catalogBreadCrumb"}>
        {linkList.map((value, index) => (
          <div key={"link" + index} style={{ display: "flex" }}>
            <Link to={value.path} className="link">{value.label}</Link>
            <div className="lastLabel">&gt;</div>
          </div>
        ))}
        <div className="lastLabel">よくあるご質問</div>
      </div>
    </div>
  );
};
